<template>
  <validation-observer
    v-if="shouldQuestionRender && isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      id="business-mileage"
      v-bind="observer"
      :validated="formObserver.validated && observer.failed"
    >
      <form-row
        :label="productName === 'van' ? 'What is your annual business mileage?' : 'If you have requested business use, what is your annual business mileage?'"
        help-text="This should be business miles only over the year and should not include social mileage."
        :error="formObserver.validated && observer.failed"
      >
        <validation-provider
          v-slot="{ errors, failedRules }"
          :vid="`${stepId}_business-mileage`"
          name="Business Mileage"
          :rules="{
            mileage: {
              minValue: 1,
              maxValue: stepData.annualMileage || 99999,
              required: shouldQuestionRender,
            },
          }"
        >
          <qz-number-input
            v-model.number="questionData.businessMileage"
            :data-test="fieldTrackerId"
            :error-messages="getFieldErrors('businessMileage', failedRules, errors) || errors"
            :placeholder="placeholder || 'e.g. 5000'"
            suffix="miles"
            :maxlength="businessMileageMaxlength"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-business-mileage',
  extends: QuestionBase,
  props: {
    placeholder: {
      default: null,
      validator: value => (typeof value === 'string') || value === false,
    },
  },
  data () {
    return { fields: ['businessMileage'] };
  },
  computed: {
    businessMileageMaxlength () {
      return this.stepData.annualMileage ? this.stepData.annualMileage.toString().length : this.inputCharsLimiters.BUSINESS_MILEAGE;
    },
    fieldTrackerId () {
      return snakeCase(this.questionFields.businessMileage);
    },
  },
};
</script>
